import Vue from 'vue'

const memberStore = {
    state:{
        remarkModify: false,
        resentvisit: false,
        dev: false,
        cart: false,
        tagChange: false,
        groupChange: false,
    },
    mutations: {
        modify(state,payload) {
            state.remarkModify = payload
        },
        visit(state,payload) {
            state.resentvisit = payload
        },
        visitDev(state,payload) {
            state.dev = payload
        },
        topay(state,payload) {
            state.cart = payload
        },
        SET_TAG(state,payload) {
            state.tagChange = payload
        },
        SET_GROUP(state,payload) {
            state.groupChange = payload
        }
    }
} 

export default memberStore